export const payload = {
  receiveMutation: 'RECEIVE_PRODUCTIONS',
  receivingMutation: 'RECEIVING_PRODUCTIONS',
  receiveMetadataMutation: 'RECEIVE_PRODUCTION_METADATA',
  receiveFailureMutation: 'RECEIVE_PRODUCTION_FAILURE',
  savingMutation: 'SAVING_PRODUCTION',
  saveFailureMutation: 'SAVING_PRODUCTION_FAILURE',
  incrementMutation: 'INCREMENT_PRODUCTION_COUNT',
  updatingMutation: 'UPDATING_PRODUCTION',
  updateFailureMutation: 'UPDATING_PRODUCTION_FAILURE',
  deleteMutation: 'DELETE_PRODUCTION',
  deletingMutation: 'DELETING_PRODUCTION',
  deleteFailureMutation: 'DELETING_PRODUCTION_FAILURE',
  resetMetaMutation: 'RESET_PRODUCTION_META',
  clearMutation: 'CLEAR_PRODUCTION_STATE',
  moduleName: 'production',
  endpoint: 'productions',
  defaultModelGetter: 'getDefaultProduction',
  searchableFields: ['code', 'name', 'description']
}
